import { RichTextViewer, getPlainTextPreview } from "@/components/ui/RichTextEditor";

interface IdeaConceptDisplayProps {
  concept: string | null | undefined;
  variant?: "full" | "preview" | "card";
  maxLength?: number;
  className?: string;
}

/**
 * Centralized component for rendering idea concept content.
 *
 * Variants:
 * - "full": Rich text via BlockNote (modals, detail views)
 * - "preview": Plain text truncated (lists, compact cards)
 * - "card": Compact rich text with fade (post-it cards)
 */
export function IdeaConceptDisplay({
  concept,
  variant = "full",
  maxLength = 120,
  className,
}: IdeaConceptDisplayProps) {
  if (!concept || concept.trim() === "") return null;

  if (variant === "preview") {
    return (
      <p className={className}>
        {getPlainTextPreview(concept, maxLength)}
      </p>
    );
  }

  if (variant === "card") {
    return <RichTextViewer content={concept} variant="card" />;
  }

  return <RichTextViewer content={concept} className={className} />;
}
